import { Editor as EditorRef } from "@tinymce/tinymce-react";
import { useState, useEffect } from "react";
import { SSMLTag, SSMLTagsColors, volumeLevelLabels } from "shared/constants";
import CustomSlider from "shared/components/CustomSlider";
import { handleSSMLValueClick } from "shared/utils/tts-editor-helper";
import { getCurrentSSMLValue } from "features/TTS/TTSCustomEditor/utils/editorKeyDownHandler";
import MenuWrapper from "../../components/MenuWrapper";
import { Box } from "@mui/material";

interface VolumeMenuProps {
  editorRef: React.RefObject<EditorRef | null>;
  onVolumeChange?: (value: string) => void;
  onApply?: (value: string) => void;
}

export default function VolumeMenu({
  editorRef,
  onVolumeChange,
  onApply,
}: VolumeMenuProps): JSX.Element {
  const [sliderValue, setSliderValue] = useState(0);

  useEffect(() => {
    const currentValue = getCurrentSSMLValue(editorRef, SSMLTag.Volume);
    if (currentValue) {
      const valueIndex = volumeLevelLabels.findIndex(
        (label) => label === currentValue
      );
      if (valueIndex !== -1) {
        setSliderValue(valueIndex);
        if (onVolumeChange) {
          onVolumeChange(currentValue);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSliderChange = (value: number) => {
    setSliderValue(value);
    if (onVolumeChange) {
      onVolumeChange(volumeLevelLabels[value]);
    }
  };

  const applyVolume = () => {
    if (!editorRef.current) return;

    const volumeLevel = volumeLevelLabels[sliderValue];
    const tagColor = SSMLTagsColors.ProsodyTag;
    const uid = Date.now().toString();

    handleSSMLValueClick(
      editorRef,
      SSMLTag.Volume,
      volumeLevel,
      tagColor,
      [],
      uid
    );

    if (onApply) {
      onApply(volumeLevel);
    }
  };

  return (
    <MenuWrapper
      id="volume-menu-wrapper"
      showDeleteButton={false}
      editorRef={editorRef}
      tagType={SSMLTag.Volume}
      onApply={applyVolume}
    >
      <Box
        sx={{
          ml: 7,
          mt: 2,
          width: "88%",
        }}
      >
        <CustomSlider
          value={sliderValue}
          defaultValue={0}
          step={1}
          minLabel="silent"
          maxLabel="x-loud"
          labels={volumeLevelLabels}
          onSliderChange={handleSliderChange}
          showCheckButton={false}
          isVolumeMenu
        />
      </Box>
    </MenuWrapper>
  );
}
